import React, { useEffect, useState } from 'react';
import { useI18n } from '../lib/i18n';
import { Menu, X } from 'lucide-react';
export function Nav() {
  const {
    t,
    lang,
    setLang
  } = useI18n();
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollTo = (id: string) => {
    setMobileMenuOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const navLinks = [{
    id: 'marco',
    label: t('nav.marco')
  }, {
    id: 'aplicaciones',
    label: t('nav.aplicaciones')
  }, {
    id: 'motor',
    label: t('nav.motor')
  }, {
    id: 'timeline',
    label: t('nav.timeline')
  }, {
    id: 'papers',
    label: t('nav.papers')
  }, {
    id: 'autor',
    label: t('nav.autor')
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white/80 backdrop-blur-md border-b border-black/[0.06] py-3' : 'bg-transparent py-5'}`} data-id="element-159" data-mp="1u43lmgntv5hd">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-160" data-mp="1k6yzuhxw9c13">
        <div className="flex items-center gap-2 cursor-pointer" onClick={() => window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })} data-id="element-161" data-mp="2hufqtjrouo49">
          <span className="font-display text-2xl tracking-tight text-[#0A0A0F]" data-id="element-162" data-mp="282tka0qapd7u">
            CLVN–LRR™
          </span>
        </div>

        <div className="hidden md:flex items-center gap-8" data-id="element-163" data-mp="232xebvy1fbpn">
          <div className="flex items-center gap-6" data-id="element-164" data-mp="30lgxyv2yppyw">
            {navLinks.map(link => <button key={link.id} onClick={() => scrollTo(link.id)} className="text-sm text-[#4A4A55] hover:text-[#0A0A0F] transition-colors" data-id="element-165" data-mp="2vsnwcg2sixr1">
                {link.label}
              </button>)}
          </div>

          <div className="flex items-center gap-4 border-l border-black/10 pl-4" data-id="element-166" data-mp="k7590w4gvpy5">
            <button onClick={() => setLang(lang === 'es' ? 'en' : 'es')} className="text-xs font-mono text-[#4A4A55] hover:text-[#0A0A0F] transition-colors uppercase tracking-widest" data-id="element-167" data-mp="p56rbeu2jl8k">
              {lang === 'es' ? 'EN' : 'ES'}
            </button>

            <a href="https://doi.org/10.5281/zenodo.15438330" target="_blank" rel="noopener noreferrer" className="text-sm font-medium bg-[#0A0A0F] text-white px-4 py-1.5 rounded-full hover:bg-[#2A2A35] transition-colors" data-id="element-168" data-mp="17hl6fiknnwo">
              {t('nav.leerPaper')}
            </a>
          </div>
        </div>

        <button className="md:hidden text-[#4A4A55] hover:text-[#0A0A0F]" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-169" data-mp="20iiy9yl4kjyy">
          {mobileMenuOpen ? <X size={24} data-id="element-170" data-mp="25qqoulqp0rhv" /> : <Menu size={24} data-id="element-171" data-mp="25ra8q7zwlpyj" />}
        </button>
      </div>

      {mobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-white border-b border-black/[0.06] p-6 flex flex-col gap-4 shadow-sm" data-id="element-172" data-mp="2jif1qr8rnjzw">
          {navLinks.map(link => <button key={link.id} onClick={() => scrollTo(link.id)} className="text-left text-lg text-[#0A0A0F] hover:text-violet-700" data-id="element-173" data-mp="2tdywvbfiaenl">
              {link.label}
            </button>)}
          <div className="h-px bg-black/[0.08] my-2" data-id="element-174" data-mp="32ddju0wgs73c" />
          <div className="flex items-center justify-between" data-id="element-175" data-mp="2yffvt1efjr1j">
            <button onClick={() => setLang(lang === 'es' ? 'en' : 'es')} className="text-sm font-mono text-[#4A4A55] hover:text-[#0A0A0F] uppercase tracking-widest" data-id="element-176" data-mp="181f9twqbz76e">
              {lang === 'es' ? 'Switch to English' : 'Cambiar a Español'}
            </button>
            <a href="https://doi.org/10.5281/zenodo.15438330" target="_blank" rel="noopener noreferrer" className="text-sm font-medium bg-[#0A0A0F] text-white px-4 py-2 rounded-full" data-id="element-177" data-mp="1ag3puubf7bbj">
              {t('nav.leerPaper')}
            </a>
          </div>
        </div>}
    </nav>;
}